"use strict";

exports.__esModule = true;
exports.AlertsConditionConfiguration = exports.ALERT_CREATION_CONDITION_INDEX = void 0;
var _react = _interopRequireWildcard(require("react"));
var _AlertDefinitionPanel = require("../../../../Components/EnrichDefinitionPanel/AlertDefinitionPanel");
var _EnrichDefinitionContext = require("../../../../Components/EnrichDefinitionPanel/EnrichDefinitionContext");
var _styles = require("../styles");
var _reactIntl = require("react-intl");
var _utils = require("./utils");
var _Device = require("../../../Device");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ALERT_CREATION_CONDITION_INDEX = exports.ALERT_CREATION_CONDITION_INDEX = 0;
var AlertsConditionConfiguration = exports.AlertsConditionConfiguration = function AlertsConditionConfiguration(props) {
  var devices = props.devices;
  var plantDevices = (0, _react.useContext)(_Device.DeviceListContext);
  var filteredSelectedDevices = plantDevices.filter(function (device) {
    return devices.includes(device.uuid);
  });
  var dataItems = (0, _utils.getCommonSampleDataItems)(filteredSelectedDevices);
  return /*#__PURE__*/_react["default"].createElement(_styles.AlertsConditionConfigurationWrapper, {
    "data-testid": "AlertsConditionConfiguration.container"
  }, /*#__PURE__*/_react["default"].createElement(_EnrichDefinitionContext.EnrichDefinitionContext.Provider, {
    value: {
      classifications: [],
      dataItems: dataItems
    }
  }, /*#__PURE__*/_react["default"].createElement(_AlertDefinitionPanel.AlertDefinitionPanel, {
    index: ALERT_CREATION_CONDITION_INDEX
  })), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_styles.AlertsConditionConfigurationLabel, null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "AlertsConditionConfiguration.label",
    defaultMessage: "Created alerts will be saved in the rules DSL editor under the device's profile"
  })));
};